<template>
    <div class="thank-you-page">
        <div class="image-wrap">
            <img src="../assets/fb_logo_big.png"/>
        </div>
        <h1>Dziękujemy<span class="purple-text">.</span></h1>

        <img class="smile" src="../assets/smile.png" />

        <h3>Pamiętaj o aktywacji</h3>
        <p>linka wysłanego na Twój adres mailowy</p>
    </div>
</template>

<script>
    export default {
        name: "ThankYou"
    }
</script>

<style scoped lang="scss">

</style>